import formatDuration from "@utils/formatDuration"

function DurationRenderer(props) {
    const { value } = props
    return <>{formatDuration(value)}</>
}

export default DurationRenderer
